// extracted by mini-css-extract-plugin
export default {"Description":"Description_Description__BJrgo"};